import SocialMediaContent from '@/components/Help/SocialMediaContent'
import SubjectsComponent from '@/components/Help/SubjectsComponent'
import Layout from 'layout/Layout'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useRef, useState } from 'react'
import { getCategoryDetail, listArticleForCategory } from 'services/allServices'
import { useTranslation } from "next-i18next";
import { useRouter } from 'next/router'
import { useGlobalStore } from 'store/GlobalStore'
import Head from 'next/head'
import ArticleImageModal from '@/components/Help/ArticleImageModal'

const index = ({ articleForCategory, categoryDetail, locale }) => {
    const { t } = useTranslation(["common", "nav", "help"]);
    const [setOtherCategoriesWiki] = useGlobalStore((state) => [state.setOtherCategoriesWiki]);
    const articleRef = useRef(null);
    const router = useRouter();
    const defaultNoImage = '/noImageWiki.png';
    const [heading, setHeading] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        setOtherCategoriesWiki(categoryDetail?.other_categories)

        if (articleRef.current) {
            const emptyParagraphs = articleRef.current.querySelectorAll('p:empty');
            emptyParagraphs.forEach((p) => {
                p.style.display = 'block';
                p.style.height = '16px';
                p.style.margin = '8px 0';
            });

            const titleStyle = articleRef.current.querySelectorAll('h3');
            titleStyle.forEach((h3) => {
                h3.style.fontWeight = 'bold';
                h3.style.fontSize = '24px';
            });

            const contentsHeading = Array.from(titleStyle).map((title, index) => ({
                id: `heading-${index}`,
                title: title.textContent,
                element: title
            }))

            contentsHeading.forEach((heading) => {
                heading.element.id = heading.id;
            });
            setHeading(contentsHeading);

            const imageTags = Array.from(articleRef.current.querySelectorAll('img'));
            imageTags?.forEach((img) => {
                img.style.cursor = "pointer";
                img.addEventListener("click", () => {
                    setSelectedImage(img.src);
                    setIsModalOpen(true);
                });
            });

            return () => {
                imageTags.forEach((img) => {
                    img.removeEventListener("click", () => {
                        setSelectedImage(img.src);
                        setIsModalOpen(true);
                    });
                });
            };
        }

    }, [categoryDetail])

    return (
        <Layout>
            <Head>
                <title>{categoryDetail?.category[0]?.meta_title}</title>
                <meta name="description" content={categoryDetail?.category[0]?.meta_description} />
                <meta property="og:title" content={categoryDetail?.category[0]?.meta_title} key="title" />
                <meta property="og:description" content={categoryDetail?.category[0]?.meta_description} key="description" />
                <meta property="og:image" content={categoryDetail?.category[0]?.image ? process.env.NEXT_PUBLIC_FRONTPAGE_URL + categoryDetail?.category[0]?.image : "https://makdos.com/headerLogo.png"} />
            </Head>

            <div className="w-full bg-slate-100 lg:bg-white">
                <div className="w-full h-[228px] lg:!h-[264px] items-center justify-center flex bg-makdosYellow "></div>

                <div className="container z-30 mx-auto -mt-40 lg:-mt-72 lg:py-16">
                    <div className="grid lg:gap-6 lg:grid-cols-12">
                        <div className="order-last space-y-6 lg:block lg:col-span-3 lg:order-first">
                            <div className="col-span-1 p-2 rounded-md cursor-pointer lg:p-3 bg-makdosSecondaryGray lg:bg-white">
                                <div className='mx-0 bg-white rounded-md'>
                                    <SubjectsComponent articleForCategory={articleForCategory} locale={locale} />
                                </div>
                            </div>

                            <div className='hidden lg:block'>
                                {categoryDetail?.category[0]?.highlights.length > 0 && <Link href={`${categoryDetail?.category[0]?.highlights?.link}`} as={`${categoryDetail?.category[0]?.highlights?.link}`} target="_blank">
                                    <Image
                                        src={`${categoryDetail?.category[0]?.highlights?.img ? process.env.NEXT_PUBLIC_FRONTPAGE_URL + categoryDetail?.category[0]?.highlights?.img : defaultNoImage}`}
                                        width={398}
                                        height={518}
                                        alt={`${categoryDetail?.category[0]?.highlights?.image_alt_text}`}
                                        title={`${categoryDetail?.category[0]?.highlights?.image_title}`}
                                        className='cursor-pointer'
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = defaultNoImage
                                            currentTarget.srcset = defaultNoImage
                                        }}
                                    />
                                </Link>}
                            </div>
                        </div>

                        <div className="order-first col-span-1 lg:mx-0 lg:col-span-6 lg:order-2">
                            <div className="col-span-1 p-4 bg-white rounded-md lg:col-span-6 lg:p-7">
                                <div className="relative w-full  h-[211px] lg:h-[425px]">
                                    <Image
                                        src={categoryDetail?.category[0]?.image ? process.env.NEXT_PUBLIC_FRONTPAGE_URL + categoryDetail?.category[0]?.image : defaultNoImage}
                                        layout="fill"
                                        alt={categoryDetail?.category[0]?.image_description}
                                        title={categoryDetail?.category[0]?.image_title}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = defaultNoImage
                                            currentTarget.srcset = defaultNoImage
                                        }}
                                    />
                                </div>

                                <div>
                                    <h1 className="pt-4 text-4xl font-semibold text-black">{categoryDetail?.category[0]?.title}</h1>
                                </div>

                                <div className="pt-4 font-bold text-black">
                                    <p>{categoryDetail?.category[0]?.description}</p>
                                </div>

                                <div className="pt-4 whitespace-pre-line article-content" ref={articleRef} dangerouslySetInnerHTML={{ __html: categoryDetail?.category[0]?.message }}>

                                </div>
                            </div>
                        </div>

                        <div className="hidden lg:block lg:space-y-6 lg:order-last lg:col-span-3">
                            {heading && heading.length > 0 && <div className="p-6 bg-white rounded-md">
                                {/*  Makalenin içindekiler bölümü */}
                                <h5 className="flex justify-between text-xl font-semibold">
                                    <span>{t("help:contents")}</span>
                                </h5>

                                <ul className="mt-4 space-y-2">

                                    {heading.map((head) => (
                                        <li key={head.id} className="py-4 border-b border-buttonBg">
                                            <a href={`#${head.id}`} className="text-textGray" onClick={(e) => {
                                                e.preventDefault();

                                                const element = document.getElementById(head.id);
                                                if (element) {
                                                    const offset = 105;
                                                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                                                    const offsetPosition = elementPosition - offset;

                                                    window.scrollTo({
                                                        top: offsetPosition,
                                                        behavior: "smooth"
                                                    });
                                                }
                                            }}>
                                                {head.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            }
                            <div>
                                <SocialMediaContent />
                            </div>

                        </div>
                        {/* } */}
                    </div>
                </div>
            </div >
            <ArticleImageModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                imageSrc={selectedImage}
            />
        </Layout >
    )
}

export default index

export const getServerSideProps = async ({ locale, query }) => {

    const languageId = locale === "tr" ? 1 : 2;

    let articleForCategory = {}
    await listArticleForCategory(languageId).then((res) => {
        articleForCategory = res;
    })

    let categoryDetail = {}
    await getCategoryDetail(query.category, languageId).then((res) => {
        if (res.status === "category_not_found") {
            categoryDetail = "category_not_found"
        } else {
            categoryDetail = res;
        }
    })



    if (categoryDetail === "category_not_found") {
        return {
            redirect: {
                destination: languageId === 1 ? "/yardim" : "/help",
                permanent: false,
            },
        }

    }

    return {
        props: {
            ...await serverSideTranslations(locale, ["common", "nav", "help"]),
            articleForCategory: articleForCategory,
            categoryDetail: categoryDetail,
            locale: locale
        }
    };
};